import { epicLaunchSessionIdAtom } from '@/atoms/integrations/integrationAtoms';
import { externalLaunchContextAtom } from '@heidi/integrations/ehr/data/atoms';
import { useAtomValue } from 'jotai';

/**
 * The session an EHR launch resolved, empty outside a launch or when it resolved
 * none. Both atoms are app state, so this stays app-side and the resolved id is
 * what crosses into a package surface.
 */
export const useEhrLaunchSessionId = (): string => {
  const epicLaunchSessionId = useAtomValue(epicLaunchSessionIdAtom);
  const externalLaunchContext = useAtomValue(externalLaunchContextAtom);
  return epicLaunchSessionId || externalLaunchContext?.sessionId || '';
};
